<template>
  <div class="choice-wrapper">
    <label class="checkbox">
      <div class="wrap">
        <font-awesome-icon v-if="isChecked" icon="check"></font-awesome-icon>
      </div>
      <input v-model="internal" type="checkbox" :value="value" />
      <slot></slot>
    </label>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AppCheckbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {},
    value: {
      default: 'on'
    }
  },
  computed: {
    internal: {
      get() {
        return this.checked;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    isChecked() {
      if (Array.isArray(this.checked)) {
        return this.checked.includes(this.value);
      }
      return !!this.checked;
    }
  }
};
</script>

<style lang="scss">
.checkbox {
  position: relative;
  display: flex !important;
  align-items: center;
  padding-right: 5px;
  input {
    opacity: 0;
    margin-right: 8px;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
  .wrap {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 2px;
    left: 0;
    border: solid 1px $input-border-color;
    border-radius: $radius;
    font-size: 12px;
    padding: 2px;
    color: $primary;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.large {
  .checkbox {
    input {
      width: 34px;
      height: 34px;
    }

    .wrap {
      width: 34px;
      height: 34px;
      font-size: 22px;
    }
  }
}
</style>
